import React from "react";
import { useEffect, useMemo, useState } from "react";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedProductLayout } from "../../../../reducers/slices/selection";
const OPTIONS = [
    { identifier: "list", icon: React.createElement(Icon, { icon: "hugeicons:right-to-left-list-dash", width: "16", height: "16" }), selected: false },
    { identifier: "grid", icon: React.createElement(Icon, { icon: "hugeicons:grid-view", width: "16", height: "16" }), selected: true },
];
export function useLayoutOptionsState() {
    const dispatch = useDispatch();
    const [options, setOptions] = useState(OPTIONS);
    const { productLayout } = useSelector((state) => state.selectionState);
    useEffect(() => {
        handleChangeLayout(productLayout);
    }, []);
    const handleChangeLayout = (target) => {
        setOptions((prevValue) => [...prevValue.map(({ identifier, ...rest }) => ({ identifier, ...rest, selected: identifier === target }))]);
        dispatch(setSelectedProductLayout(target));
    };
    return useMemo(() => ({
        handleChangeLayout,
        options,
    }), [handleChangeLayout, options]);
}
